import React, { useState } from 'react';
import { Mail, Share2, Loader2 } from 'lucide-react';
import { publicApi } from '../../api';
import { ShareScoreModal } from './ShareScoreModal';

export const PastScoreLookup = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [found, setFound] = useState(null);

  const lookup = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      setFound(await publicApi.getMyScore(email.trim()));
    } catch (err) {
      const s = err?.response?.status;
      setError(s === 404 ? 'No saved score for this email yet. Play and save your score first.'
        : s === 429 ? 'Too many tries. Wait a minute and try again.' : 'Enter a valid email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="past-score-lookup" className="mt-10 bg-white rounded-3xl crunch-shadow-sm border-2 border-[#1a1a1a] p-5 md:p-6">
      <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Share later</div>
      <h3 className="font-display text-2xl md:text-3xl uppercase mt-1">Share your saved score</h3>
      <p className="font-brico text-sm opacity-70 mt-1">Enter the email you used for the contest to get your best score card.</p>
      <form onSubmit={lookup} className="mt-4 flex flex-col sm:flex-row gap-3">
        <div className="flex-1 flex items-center gap-2 bg-[#FFF4E6] rounded-2xl border-2 border-[#1a1a1a] px-4">
          <Mail size={16} />
          <input data-testid="past-score-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Your contest email" className="flex-1 py-3 bg-transparent focus:outline-none font-brico" />
        </div>
        <button data-testid="past-score-find-btn" type="submit" disabled={loading} className="btn-chunky primary justify-center">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Share2 size={16} />} Get my card
        </button>
      </form>
      {error && <p data-testid="past-score-error" className="mt-3 text-sm font-brico text-[#E63946]">{error}</p>}
      {found && <ShareScoreModal score={found.score} initialName={found.name} onClose={() => setFound(null)} />}
    </div>
  );
};
